// extracted by mini-css-extract-plugin
export default {"Tab":"styles_Tab__iArZs","active":"styles_active__pANoo","count":"styles_count__ndXvj"};